import { render } from "./multiTable.vue?vue&type=template&id=27b38cba"
import script from "./multiTable.vue?vue&type=script&lang=js"
export * from "./multiTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__